import { CouponsService } from '@mc/api'
import { getDefaultSubscriptionPlanIdAsync } from '@mc/products'

export const fetchDiscountData = async (code: string) => {
  const productId = await getDefaultSubscriptionPlanIdAsync()
  const discountData = await CouponsService.verifyCoupon({ code, productId })
  return discountData
}
